import { useMemo } from 'react';
import { useFeatureIsOn } from '../contexts';
import { AB_TEST_TAB_PREFIX, computeDocumentsContentToDisplay } from '../utils';

export const useHandlePrismicAbTests = <
  TDocument extends { feature_flag_key: string | null },
>(
  document: TDocument | null,
) => {
  const isAbTestEnabled = useFeatureIsOn(document?.feature_flag_key ?? '');

  return useMemo(() => {
    if (!document) {
      return null;
    }

    return computeDocumentsContentToDisplay({
      document,
      abTestTabPrefix: AB_TEST_TAB_PREFIX,
      isAbTestEnabled,
    });
  }, [document, isAbTestEnabled]);
};
